import React, {useState} from 'react'
import { useTranslation } from 'react-i18next'
import {Row, Col, ButtonGroup, Button, Card, CardHeader, CardBody, CardFooter} from 'reactstrap'
import Modal from 'ui/modal'
import cn from 'classnames'

const MenuModal = (props) => {
  const {menuModal, toggleMenuModal, filteredSpecialRequests, allergensList, enabledSelectAll, passenger, addon, passengerIndex, snackAddon, selected, setSelected, onSelectMenuForAll} = props
  const { i18n } = useTranslation()

  return (
    <Modal
      isOpen={menuModal}
      toggle={toggleMenuModal}
      header={i18n.t('menu_modal.title')}
      closeOverlay={false}
    >
      <Menus filteredSpecialRequests={filteredSpecialRequests} allergensList={allergensList} enabledSelectAll={enabledSelectAll} passenger={passenger} addon={addon} passengerIndex={passengerIndex} snackAddon={snackAddon} selected={selected} setSelected={setSelected} onSelectMenuForAll={onSelectMenuForAll}/>
    </Modal>
  )
}

const Menus = (props) => {
  const {filteredSpecialRequests, allergensList, enabledSelectAll, passenger, addon, passengerIndex, snackAddon, selected, setSelected, onSelectMenuForAll} = props
  const { i18n } = useTranslation()

  return (
    <div style={{overflowY: 'scroll', height: '550px'}}>
      {filteredSpecialRequests.filter(({type}) => type == 'ME').map((request) => {
        const {code, type, name, description, allergens} = request

        const allergensData = allergensList.filter((a) => allergens && allergens.includes(a.code))

        const onSelectMenu = (passenger, addon, specialRequest) => {
          let passengerAddons = [{
            passengerId: passenger.id,
            tariffCode: addon.passenger_fares[passengerIndex].tariff_code,
            specialRequests: [
              {
                type: specialRequest.type,
                code: specialRequest.code
              }
            ]
          }]

          if (snackAddon) {
            passengerAddons.push({
              passengerId: passenger.id,
              tariffCode: snackAddon.passenger_fares[passengerIndex].tariff_code,
            })
          }

          let newMenus = {}

          if (selected.menus) { newMenus = selected.menus }

          newMenus[passenger.id] = passengerAddons
          setSelected({...selected, menus: newMenus})
        }

        return (
          <Col xs="12" className="mb-3">
            <Card>
              <CardHeader>
                <strong>{name}</strong>
              </CardHeader>
              <CardBody>
                {description}

                {allergensData && allergensData.length > 0 &&
                  <React.Fragment>
                    <hr/>

                    <i>{i18n.t('menus.allergens')}: {allergensData.map((ad) => ad.name).join(', ')}</i>
                  </React.Fragment>
                }
              </CardBody>
              <CardFooter>
                <ButtonGroup className="w-100">
                  <Button color="primary text-white" onClick={() => onSelectMenu(passenger, addon, request)}>
                    {i18n.t('format:actions.select')}
                  </Button>
                  {enabledSelectAll &&
                    <Button onClick={() => onSelectMenuForAll(addon, request, selected, setSelected, snackAddon)}>
                      {i18n.t('format:actions.select_for_all')}
                    </Button>
                  }
                </ButtonGroup>
              </CardFooter>
            </Card>
          </Col>
        )
      })}
    </div>
  )
}

const BistroModal = (props) => {
  const {bistroModal, setBistroModal, toggleBistroModal, availability, selected, filteredSpecialRequests, allergensList, addon, snackAddon, setSelected, onSelectMenuForAll, onConfirmProduct} = props
  const { i18n } = useTranslation()
  const passengers = availability.offer.passengers.filter((p) => p.type != 'IN')

  const menuSelectPending = passengers
    .map((passenger) => selected.menus && selected.menus[passenger.id])
    .some((selected) => !selected)

  return (
    <Modal
      isOpen={bistroModal}
      toggle={toggleBistroModal}
      header={i18n.t('bistro_modal.title')}
      closeOverlay={false}
    >
      <Row className={cn(['row row-cols-1 row-cols-md-2 mx-0 mb-3', passengers.length > 2 ? 'justify-content-start' : 'justify-content-center'])}>
        {passengers.map((passenger, i) => {
          const passenger_type = availability.passenger_types.find((pt) => pt.code == passenger.type)
          const fare = selected.product.items[0].passenger_fares[i]
          const product = availability.products.find((p) => p.code == fare.product_code)

          const [menuModal, setMenuModal] = useState()
          const toggleMenuModal = () => setMenuModal(!menuModal)

          const selectedMenu = selected.menus && selected.menus[passenger.id] && selected.menus[passenger.id].filter((addon) => {
            if (!snackAddon) { return true }

            return addon.tariffCode != snackAddon.passenger_fares[i].tariff_code
          })[0]
          const specialRequest = selectedMenu && filteredSpecialRequests.find((sr) => selectedMenu.specialRequests[0].code == sr.code)
          const specialRequestName = specialRequest && specialRequest.name

          return (
            <Col>
              <MenuModal 
                menuModal={menuModal} 
                toggleMenuModal={toggleMenuModal} 
                filteredSpecialRequests={filteredSpecialRequests}
                allergensList={allergensList}
                passenger={passenger}
                enabledSelectAll={passengers.length > 1}
                addon={addon}
                specialRequest={specialRequest}
                passengerIndex={i}
                snackAddon={snackAddon}
                selected={selected}
                setSelected={setSelected}
                onSelectMenuForAll={onSelectMenuForAll}
              />
              <Card className="mb-3">
                <CardHeader>
                  <div className="d-flex justify-content-between">
                    <div>
                      {specialRequestName ? (
                        <span>{passenger_type.description}: {specialRequestName}</span>
                      ) : (
                        <span>{passenger_type.description}</span>
                      )}
                    </div>
                    <div>
                      {specialRequestName &&
                        <i className="fa fa-check text-success"/>
                      }
                    </div>
                  </div>

                </CardHeader>
                <CardBody>
                  <Button onClick={() => setMenuModal(true)} className="w-100 text-white" color={specialRequestName ? "dark" : "primary"}>
                    {selectedMenu ? i18n.t('iryo_train_module.change_menu') : i18n.t('iryo_train_module.select_menu')}
                  </Button>
                </CardBody>
              </Card>
            </Col>
          )
        })}
      </Row>

      <hr/>

      <Row>
        <Col className="text-center">
          <Button
            disabled={menuSelectPending}
            color="success"
            onClick={() => {
              setBistroModal(false)
              onConfirmProduct()
            }}
          >
            {i18n.t('iryo_train_module.confirm_menu')}
          </Button>
        </Col>
      </Row>
    </Modal>
  )
}

export default BistroModal